export default __webpack_public_path__ + "static/media/profile.b5c9cb77.png";